module.exports = __webpack_public_path__ + "img/toto_0.ee3f2583.jpg";